/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { ModalHeader } from '@carbon/react';

import { deploymentTypes, modes } from 'App/Pages/Diagram/features/deployment/utils';

export default function Header({ mode, deploymentType, onClose }) {
  const title = getTitle(mode, deploymentType);

  return <ModalHeader title={title} closeModal={onClose} />;
}

const getTitle = (mode, deploymentType) => {
  const deploymentTypeLabel = getDeploymentTypeLabel(deploymentType);

  if (mode === modes.DEPLOY) {
    return `Deploy ${deploymentTypeLabel}`;
  } else if (mode === modes.EXECUTE) {
    return 'Start instance';
  }

  return null;
};

const getDeploymentTypeLabel = (deploymentType) => {
  if (deploymentType === deploymentTypes.DIAGRAM) {
    return 'diagram';
  } else if (deploymentType === deploymentTypes.PROCESS_APPLICATION) {
    return 'process application';
  }

  return '';
};
